import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import {
  Phone as PhoneIcon,
  PhoneDisabled as PhoneDisabledIcon,
  HourglassEmpty as HourglassIcon
} from '@mui/icons-material';
import api from '../config/api';
import { useApiError } from '../hooks/useApiError';

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    conectados: 0,
    desconectados: 0,
    pendentes: 0
  });
  
  const { handleError } = useApiError();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/instancias');
        const instancias = response.data;

        const stats = instancias.reduce(
          (acc, instancia) => {
            acc.total++;
            acc[instancia.status_conexao]++;
            return acc;
          },
          {
            total: 0,
            conectados: 0,
            desconectados: 0,
            pendentes: 0
          }
        );

        setStats(stats);
      } catch (error) {
        handleError(error, 'Erro ao carregar estatísticas do dashboard');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [handleError]);

  const StatCard = ({ title, value, icon, color }) => (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 140
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="text.secondary" gutterBottom>
          {title}
        </Typography>
        {icon}
      </Box>
      <Typography component="p" variant="h4" sx={{ mt: 2 }}>
        {value}
      </Typography>
    </Paper>
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total de Instâncias"
            value={stats.total}
            icon={<PhoneIcon color="primary" />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Conectados"
            value={stats.conectados}
            icon={<PhoneIcon color="success" />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Desconectados"
            value={stats.desconectados}
            icon={<PhoneDisabledIcon color="error" />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Pendentes"
            value={stats.pendentes}
            icon={<HourglassIcon color="warning" />}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard; 